import { useEffect, useMemo, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import useLogAcesso from "~fetchs/useLogAcesso";
import useUsuario from "~fetchs/useUsuario";
import { AcessosSlug } from "~services/GlobalServices";
import { initialPath } from "~misc/paths";
const CheckAccessRoute = ({ element: Element, accessKey, skipAccessCheck = false, ...rest }) => {
  const { usuario } = useUsuario();
  useLogAcesso();
  const [isReady, setIsReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsReady(true);
  }, []);

  const isAccessAllowed = useMemo(() => {
    if (!isReady) return false;
    if (skipAccessCheck) return usuario?.ativo;
    return usuario?.ativo && AcessosSlug(usuario?.slugAcessos, accessKey);
  }, [usuario, accessKey, isReady, skipAccessCheck]);

  const isRestrictedOnlyReflex = usuario?.slugAcessos?.includes("acesso-somente-ao-menu-de-reflex");

  if (!isReady) return null;

  if (isRestrictedOnlyReflex) {
    const reflexBase = `${initialPath}/reflex`;
    if (!location.pathname.startsWith(reflexBase)) {
      return <Navigate to={`${reflexBase}/mes-atual`} replace />;
    }
    return <Element {...rest} />;
  }

  return isAccessAllowed ? <Element {...rest} /> : null;
};

export default CheckAccessRoute;
